export default {"src":"/_next/static/media/private-cloud.5160215a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};